import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './parts.css'

/**
 * The footer region of a composed [Drawer](/components/drawer/). A fixed zone at
 * the bottom of the drawer, typically holding actions.
 *
 * Auto-assigns itself to the drawer's `footer` slot, so place it as a direct
 * child of `nord-drawer` (no `slot` attribute needed).
 *
 * @status draft
 * @category structure
 * @lightDom true
 *
 * @slot - The drawer footer content.
 */
@customElement('nord-drawer-footer')
export default class DrawerFooter extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    if (!this.hasAttribute('slot')) {
      this.setAttribute('slot', 'footer')
    }
    injectLegacyLightDomStyles(this, style, 'nord-drawer-parts')
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-drawer-footer': DrawerFooter
  }
}
